/*** IMPORTS FROM imports-loader ***/
(function() {

module.exports = global["$"] = require("-!./jquery.js");
}.call(window));


//////////////////
// WEBPACK FOOTER
// ./~/jquery/dist/jquery.js-exposed
// module id = 1
// module chunks = 0